import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { Alert, Collapse } from '@mui/material';
import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { isOtpActive } from '!core/redux/dbConfigurations';
import { ButtonMain } from '»components/atoms/Buttons';
import { TrlTextField } from '»components/atoms/Inputs';

import { loginServices } from '../login.services';
import {
  CloseIconStyled,
  InputsContainerStyled,
  LabelStyled,
  ModalStyled,
  PasswordRecover,
  SubmitButtonContainerStyled,
} from './RecoverModal.syles';
import { recoverModalValidation } from './recoverModal.yup';

export const RecoverModal = ({ isDisabled }) => {
  const [open, setOpen] = useState(false);
  const [openFeed, setOpenFeed] = useState(false);

  const useOtp = useSelector((state) =>
    isOtpActive(state, 'ENFORCE_OTP_LOGIN'),
  );

  const recoverPassword = ({ user }) => {
    loginServices.passwordRecover({ userId: user });
    setOpenFeed(true);
    setTimeout(handleClose, 3000);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenFeed(false);
  };

  const handleClosefeed = () => {
    setOpenFeed(false);
  };

  return (
    <>
      <LabelStyled
        onClick={handleOpen}
        aria-hidden
        aria-disabled={isDisabled}
        useOtp={useOtp}
      >
        <FormattedMessage id="TRLT_UI-RECOVER_PASSWORD" />
      </LabelStyled>

      <ModalStyled
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <PasswordRecover>
          <Formik
            initialValues={{ user: '' }}
            onSubmit={recoverPassword}
            validationSchema={recoverModalValidation()}
            enableReinitialize
          >
            {({ dirty, isSubmitting, isValid }) => (
              <Form>
                <PasswordRecover id="passwordrecover">
                  <CloseIconStyled
                    icon={faXmark}
                    onClick={handleClose}
                    className="exit"
                  />
                  <InputsContainerStyled>
                    <Collapse in={openFeed}>
                      <Alert
                        severity="success"
                        sx={{ width: '100%', margin: 1 }}
                        open={openFeed}
                        onClose={handleClosefeed}
                      >
                        <FormattedMessage id="TRLT_UI-EMAIL_SENT" />
                      </Alert>
                    </Collapse>
                    <p className="bem-vindo">
                      <FormattedMessage id="TRLT_UI-RECOVERY_PASSWORD" />
                    </p>
                    <TrlTextField
                      name="user"
                      type="text"
                      label={<FormattedMessage id="TRLT_UI-USER" />}
                      id="user"
                      autoComplete="username"
                    />
                  </InputsContainerStyled>

                  <SubmitButtonContainerStyled class="submitBtnContainer">
                    <ButtonMain
                      expressionId="TRLT_UI-SEND"
                      type="submit"
                      id="submit"
                      disabled={!dirty || isSubmitting || !isValid}
                    />
                  </SubmitButtonContainerStyled>
                </PasswordRecover>
              </Form>
            )}
          </Formik>
        </PasswordRecover>
      </ModalStyled>
    </>
  );
};

RecoverModal.propTypes = {
  isDisabled: PropTypes.bool,
};
